import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setPageContext } from '../shared/api/pageContext';

export function PageContextTracker() {
  const location = useLocation();

  useEffect(() => {
    setPageContext(location.pathname);
  }, [location.pathname]);

  return null;
}
